import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import {
  routerMiddleware,
  routerReducer,
} from "react-router-redux";
import createSagaMiddleware from 'redux-saga';
import firebase from 'firebase'
import { firebaseReducer, getFirebase, reactReduxFirebase } from 'react-redux-firebase';
import { firestoreReducer, reduxFirestore } from 'redux-firestore'
import { reducer as formReducer } from 'redux-form';

import activeCategory from '../reducers/activeCategory';
import activeManageEventId from '../reducers/activeManageEventId';
import alertBanner from '../reducers/alertBanner';
import events from '../reducers/events';
import { fbConfig } from '../../firebase/config';
import get from '../reducers/get';
import google from '../reducers/google';
import history from '../store/history';
import lastSavedEventId from '../reducers/lastSavedEventId';
import rootSaga from '../sagas';
import searchTerm from '../reducers/search';
import signIn from '../reducers/signIn';
import signUp from '../reducers/signUp';
import submit from '../reducers/submit';

const rootReducer = combineReducers({
  activeCategory,
  activeManageEventId,
  alertBanner,
  events,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  form: formReducer,
  get,
  google,
  lastSavedEventId,
  router: routerReducer,
  searchTerm,
  signIn,
  signUp,
  submit,
});

const rrfConfig = {
  enableLogging: false,
  fileMetadataFactory: (uploadRes) => {
    const { metadata: {name, fullPath, size, contentType, timeCreated, updated} } = uploadRes;
    return {
      name,
      fullPath,
      size,
      contentType,
      timeCreated,
      updated,
    }
  },
  useFirestoreForProfile: true,
  useFirestoreForStorageMeta: true,
  userProfile: 'users',
};

firebase.initializeApp(fbConfig);
firebase.firestore().settings({ timestampsInSnapshots: true });

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware, routerMiddleware(history)];

const store = createStore(
  rootReducer,
  compose(
    reactReduxFirebase(firebase, rrfConfig),
    reduxFirestore(firebase),
    applyMiddleware(...middleware),
    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f,
  ),
);

sagaMiddleware.run(rootSaga, getFirebase);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store/store.js